import { en } from '../i18n/en';
import type { Messages } from '../i18n/messages';
import { ApiError } from './client';

/**
 * The alert-banner text for a failed request: the backend's `Code: description` (ADR-002),
 * except the depth cap — a product constraint ADR-027 §3 fixes together with its wording, so
 * hitting it (creating or moving a sub-planlet past 16 levels) reads as "maximum nesting
 * reached" rather than as a fault. Anything that is not an API answer is a transport failure.
 * The two client-worded texts come from the catalogue (ADR-031) — English unless the caller
 * passes the current locale's; the server's own texts are shown as they came.
 */
export function describeError(error: unknown, errors: Messages['errors'] = en.errors): string {
  if (!(error instanceof ApiError)) return errors.unreachable;
  return error.body.code === 'ResourceAccess.DepthLimitExceeded'
    ? errors.maxNesting(error.body.description)
    : error.message;
}
